<template>
  <div class="page home-page">
    <!--    <WelcomeComponent />-->
    <BannerSharesComponent :shares="banner_shares" />
    <BrandsComponent :brands="brands" />
    <CategoriesComponent :categories="main_categories" />
    <!--    <SliderComponent-->
    <!--      class="home-page__banners-slider"-->
    <!--      :items="banners"-->
    <!--      :hideArrows="true"-->
    <!--      v-slot="{ item }"-->
    <!--      :slider-options="cardsSliderOptions"-->
    <!--    >-->
    <!--      <BannerComponent :data="item" />-->
    <!--    </SliderComponent>-->
    <div class="home-page__products sides-padding">
      <div class="container">
        <div class="home-page__products-inner">
          <ProductsColComponent title="Мы рекомендуем" :items="recommend_products" />
          <ProductsColComponent title="Популярные" :items="popular_products" />
          <ProductsColComponent title="Акции" :items="shares_products" />
        </div>
      </div>
    </div>
    <div class="home-page__trends sides-padding">
      <div class="container">
        <div class="home-page__trends-inner">
          <h2 class="home-page__trends-title">Тренды сезона</h2>
          <div
            class="home-page__trends-cols"
            :class="{ 'home-page__trends-cols--no-news': !(news && news.length) }"
          >
            <ProductsColComponent :items="trend_products.slice(0, trend_products.length / 2)" />
            <TrendsColComponent :items="news" />
            <ProductsColComponent :items="trend_products.slice(trend_products.length / 2)" />
            <ProductsColComponent class="products-col--all" :items="trend_products" />
          </div>
        </div>
      </div>
    </div>
    <BottomBannerComponent :data="main_brand" />
  </div>
</template>

<script>
import WelcomeComponent from "./components/WelcomeComponent.vue";
import BannerSharesComponent from "./components/BannerSharesComponent.vue";
import CategoriesComponent from "./components/CategoriesComponent.vue";
import BannerComponent from "./components/BannerComponent.vue";
import ProductsColComponent from "./components/ProductsColComponent.vue";
import TrendsColComponent from "./components/TrendsColComponent.vue";
import BrandsComponent from "components/brands/BrandsComponent.vue";
import BottomBannerComponent from "./components/BottomBannerComponent.vue";
import SliderComponent from "components/SliderComponent.vue";
import HOME_PAGE from "@/graphql/pages/HomePage.graphql";

export default {
  name: "HomePage",
  async asyncData({ apollo, store }) {
    await apollo.defaultClient
      .query({
        query: HOME_PAGE,
      })
      .then(({ data }) => {
        store.state.home_page.main_categories = data.categories_paginate.data;
        store.state.home_page.banner_shares = data.banner_shares;
        store.state.home_page.recommend_products = data.recommend_products;
        store.state.home_page.popular_products = data.popular_products;
        store.state.home_page.shares_products = data.shares_products;
        store.state.home_page.trend_products = data.trend_products;
        store.state.home_page.main_brand = data.main_brand.data[0] || {};
        store.state.home_page.news = data.news_paginate.data;
        store.state.home_page.banners = data.banners;
        store.state.all_brands = data.brands || [];
        store.state.popular_brands = data.brands_paginate.data || [];
        store.state.categories = data.header_categories.data || [];
        store.state.pages = data.pages;
        store.state.marketplace = data.marketplace;
      })
      .catch(() => {});
  },
  data() {
    return {
      cardsSliderOptions: {
        slidesPerView: 1,
        pagination: false,
        clickable: false,
        preloadImages: true,
        loop: true,
      },
    };
  },
  computed: {
    main_categories() {
      return this.$store.state.home_page.main_categories || [];
    },
    banner_shares() {
      return this.$store.state.home_page.banner_shares || [];
    },
    recommend_products() {
      return this.$store.state.home_page.recommend_products?.data || [];
    },
    popular_products() {
      return this.$store.state.home_page.popular_products?.data || [];
    },
    shares_products() {
      return this.$store.state.home_page.shares_products?.data || [];
    },
    trend_products() {
      return this.$store.state.home_page.trend_products?.data || [];
    },
    main_brand() {
      return this.$store.state.home_page.main_brand;
    },
    news() {
      return this.$store.state.home_page.news || [];
    },
    banners() {
      return this.$store.state.home_page.banners || [];
    },
    brands() {
      return this.$store.state.popular_brands || [];
    },
  },
  components: {
    WelcomeComponent,
    BannerSharesComponent,
    CategoriesComponent,
    BannerComponent,
    ProductsColComponent,
    TrendsColComponent,
    BrandsComponent,
    BottomBannerComponent,
    SliderComponent,
  },
  metaInfo: {
    title: "BabyMarket",
    // override the parent template and just use the above title only
    titleTemplate: null,
  },
};
</script>

<style lang="stylus">
.home-page {
  display: grid;
  grid-gap: 50px;
  padding 0
  +below(840px) {
    grid-gap 30px
  }

  &__trends {
    .products-col {
      &--all {
        +above(1201px) {
          display none
        }
      }

      &:not(&--all) {
        +below(1200px) {
          display none
        }
      }
    }
  }

  &__products-inner,
  &__trends-cols {
    display grid
    grid-template-columns repeat(3, 1fr)
    gap 45px
    +below(1200px) {
      grid-template-columns 1fr
      gap 30px
    }

		&--no-news {
			grid-template-columns repeat(2, 1fr)
			+below(1200px) {
				grid-template-columns 1fr
			}
		}
  }
}
</style>
